import React from 'react';
import styled, { css } from 'styled-components';
import { fontSize, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledTable = styled.section`
  ${sectionMargins('30px', '60px')};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}

  ${({ as }) => {
    if (as === 'h4') {
      return css`
        ${fontSize(18)};

        ${minBreakpointQuery.small`
          ${fontSize(19)};
        `}

        ${minBreakpointQuery.large`
          ${fontSize(20)};
        `}
      `;
    }
  }}
`;

const Table = ({ heading, table, isTabs }) => (
  <StyledTable>
    <Container narrow={true}>
      {heading && <StyledHeading as={isTabs && 'h4'}>{heading}</StyledHeading>}
      <HtmlContent html={table} />
    </Container>
  </StyledTable>
);

export default Table;
